import { nothing, Widget } from "../widget";

export const onlyIf = <a>(condition:boolean, widget:Widget<a>) : Widget<a> =>
  condition ? widget : nothing()
